import {createSelector} from '@reduxjs/toolkit'
import {NOTIFICATION_API_ENDPOINT} from '../../../constants/backendUrls'
import {axiosBaseQuery} from '../../../rtkQueryUtils'
import {IdType} from '../../../util/models/IdType'
import {NotificationDTO} from '../../../generated/api'
import { createApi } from '@reduxjs/toolkit/query/react'

export const NOTIFICATION_TAG = 'Notification'

export const notificationAPI = createApi({
    reducerPath: 'notificationAPI',
    keepUnusedDataFor: 0,
    tagTypes: [NOTIFICATION_TAG],
    baseQuery: axiosBaseQuery({baseUrl: `${NOTIFICATION_API_ENDPOINT}/api/v1/datx/`}),
    endpoints: (builder) => ({
        getNotifications: builder.query<NotificationDTO[], void>({
            query: () => ({
                url: 'notifications/me',
                method: 'GET'
            }),
            providesTags: [NOTIFICATION_TAG]
        }),
        deleteNotification: builder.mutation<NotificationDTO, IdType>({
            query: (notificationId) => ({
                url: `notifications/${notificationId}`,
                method: 'DELETE'
            }),
            transformResponse: (response:{ data: NotificationDTO }) => response.data,
            invalidatesTags: [NOTIFICATION_TAG]
        }),
        readAllNotifications: builder.mutation<NotificationDTO[], void>({
            query: () => ({
                url : 'notifications/readAll',
                method: 'PATCH'
            }),
            transformResponse: (response: { data: NotificationDTO[] }) => response.data,
            invalidatesTags: [NOTIFICATION_TAG]      
        })
    })
})

export const selectNotifications = notificationAPI.endpoints.getNotifications.select()

export const selectUnreadNotifications = createSelector(selectNotifications, notificationResult => notificationResult.data ? notificationResult.data.filter((notification: NotificationDTO) => !notification.read).length : 0)

export const {useGetNotificationsQuery, useDeleteNotificationMutation, useReadAllNotificationsMutation} = notificationAPI